"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshValue = exports.getStorageData = void 0;
var DEFAULT_EXPIRATION_MINUTES = 10;
var getStorageData = function (key, fetcher, options) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, expire, isOnline, storage, storageValue, _b, lastFetchDate, data, isMissingData, dataAge, isDataExpired, isRefreshPossible, isTimeToRefresh;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = options.expire, expire = _a === void 0 ? DEFAULT_EXPIRATION_MINUTES : _a, isOnline = options.isOnline, storage = options.storage;
                return [4 /*yield*/, _getStorageValue(key, storage)];
            case 1:
                storageValue = _c.sent();
                _b = storageValue || {}, lastFetchDate = _b.lastFetchDate, data = _b.data;
                isMissingData = !lastFetchDate || !data;
                dataAge = _getAgeInMinutes(Number(lastFetchDate) || '');
                isDataExpired = dataAge >= expire;
                isRefreshPossible = isOnline && fetcher;
                isTimeToRefresh = isRefreshPossible && (isDataExpired || isMissingData);
                return [2 /*return*/, { data: data, isTimeToRefresh: isTimeToRefresh }];
        }
    });
}); };
exports.getStorageData = getStorageData;
var refreshValue = function (key, fetcher, storage) { return __awaiter(void 0, void 0, void 0, function () {
    var data, storageValue;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetcher()];
            case 1:
                data = _a.sent();
                if (!data) return [3 /*break*/, 3];
                storageValue = JSON.stringify({ lastFetchDate: Date.now(), data: data });
                return [4 /*yield*/, storage.setItem(key, storageValue)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.refreshValue = refreshValue;
var _getAgeInMinutes = function (date) {
    var now = Date.now();
    var difference = now - date;
    var minutes = Math.round(difference / (1000 * 60));
    return minutes;
};
var _getStorageValue = function (key, storage) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
    switch (_c.label) {
        case 0:
            _b = (_a = JSON).parse;
            return [4 /*yield*/, storage.getItem(key)];
        case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
    }
}); }); };
//# sourceMappingURL=index.js.map